module.exports = __webpack_public_path__ + "static/sample-projects-6-bea86c8036606401d94feda97d62ea35.png";